export default __webpack_public_path__ + "static/media/bg-talk-0.52075e8b.png";